import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=44938399&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style0 from "./Customers.vue?vue&type=style&index=0&id=44938399&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44938399",
  null
  
)

export default component.exports